import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BaseLayoutComponent } from './layout/base-layout/base-layout.component';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { httpInterceptorProviders } from './http-interceptors/index';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { ROOT_REDUCERS } from './state/appState.state';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { SharedModule } from './shared/shared.module';
import { CustomErrorHandler } from './handlers/custom-error.handler';
import { TurnstileAuthService } from './services/turnstile-auth/turnstile-auth.service';

@NgModule({
	declarations: [AppComponent, BaseLayoutComponent],
	providers: [
		httpInterceptorProviders,
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		{ provide: ErrorHandler, useClass: CustomErrorHandler },
		{
			provide: APP_INITIALIZER,
			useFactory: (turnstileAuth: TurnstileAuthService) => () =>
				turnstileAuth.initialize(),
			deps: [TurnstileAuthService],
			multi: true,
		},
	],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		NgbModule,
		HttpClientModule,
		ToastrModule.forRoot({ positionClass: 'inline' }),
		StoreModule.forRoot(ROOT_REDUCERS),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: environment.production,
		}),
		SharedModule,
	],
})
export class AppModule {}
